
import { FeatureManagementKey } from '../../../types';

export const featureManagement: Record<FeatureManagementKey, string> = {
  personalizations: 'Personalizações',
  personalization: 'Personalização',
  configureFeature: 'Configurar Recurso',
  featureConfigured: 'Recurso Configurado',
  featureNotConfigured: 'Não Configurado',
  clickToEdit: 'Clique para Editar',
  playbackControls: 'Controles de Reprodução',
  contentOverlays: 'Sobreposições de Conteúdo',
  appearance: 'Aparência',
  trackingEngagement: 'Rastreamento e Engajamento',
  metrics: 'Métricas',
};
